import axios from "axios";
import {responses} from "@/utils/responses";

export default {
    name: 'tickets-tasks',
    state: {
        tasks: [],
        task: {}
    },
    getters: {
        getTask: (state) => state.task,
        getTasks: (state) => state.tasks
    },
    mutations: {
        setTasks: (state, data) => {
            state.tasks = data
        },
        setTask: (state, data) => {
            state.task = data
        }
    },
    actions: {
        getTaskByID: (context, payload) => {
            return axios.get(ticketApi + `ticket/task/${payload.ticket}/${payload.id}`)
                .then(({data}) => context.commit('setTask', data));
        },

        getTaskByUserID: (context, userID) => {
            return axios.get(ticketApi + `ticket/task/*/openTask/${userID}`)
                .then(({data}) => data);
        },
        createTask: (context, data) => {
            const user = JSON.parse(localStorage.getItem('current_store'));
            data.createdBy = user.id;
            return axios.post(ticketApi + `ticket/task/${data.ticket}`, data)
                .then(({data}) => data)
                .catch(err => { errorHandler.tomcatError(err) })
        },
        editTask: (context, data) => {
            const user = JSON.parse(localStorage.getItem('current_store'));
            data.createdBy = user.id;

            // Convert `createdDate` to a string (ISO format)
            if (data.createdDate && typeof data.createdDate === "object") {
                const { date, time } = data.createdDate;
                data.createdDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')} ` +
                    `${String(time.hour).padStart(2, '0')}:${String(time.minute).padStart(2, '0')}:${String(time.second).padStart(2, '0')}`;
            }

            return axios.put(ticketApi + `ticket/task/${data.ticket}/${data.id}`, data)
                .then(({ data }) => data)
                .catch(err => { errorHandler.tomcatError(err) });
        },
        deleteTask: (context, data) => {
            return axios.delete(ticketApi + `ticket/task/${data.ticket}/${data.id}`)
                .then(({data}) => context.commit('setTasks', data))
                .catch(err => { errorHandler.tomcatError(err) })
        },
        completeTask: (context, data) => {
            return axios.post(ticketApi + `ticket/task/${data.ticket}/${data.id}/complete`)
                .then(({data}) => data)
                .catch(err => { errorHandler.tomcatError(err) })
        }
    }
}